import { Store } from 'redux';

import { IAppState } from '../../../common/state';
import { setCookieAndShowTriggerPopup } from '../actions/signInTriggerModal';

import { REGISTRATION_TRIGGER_COOKIE } from './setRegistrationTriggerCookie';

export function runRegistrationTriggerPopup(store: Store<IAppState>) {
  const cookieRegex = new RegExp(REGISTRATION_TRIGGER_COOKIE, 'ig');

  if (cookieRegex.test(window.document.cookie)) {
    return;
  }

  let mutex = false;

  setTimeout(() => {
    if (!mutex) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      store.dispatch(setCookieAndShowTriggerPopup() as any);
      mutex = true;
    }
  }, 60000);

  store.subscribe(() => {
    if (!mutex) {
      const state = store.getState();
      const {
        results: { jsonQuery },
        isSignInTriggerModalOpen,
      } = state;

      if (jsonQuery.page && jsonQuery.page.value === 2 && !isSignInTriggerModalOpen) {
        mutex = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        store.dispatch(setCookieAndShowTriggerPopup() as any);

        return;
      }
    }
  });
}
